import { AccountingBpView } from '@/components/Approval/@components/AccountingBusinessPartner';
import { parseAccountingBpContent } from '@/utils/approval/accountingBusinessPartner';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 101 회계거래처 신규/변경 — 레거시 조회처럼 저장 content 그대로(레거시 문서 포함). SAP 재조회 안 함 */
const AccountingBpSlot = ({ data }: ContentExtraProps) => {
  const content = parseAccountingBpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <AccountingBpView content={content} />
    </ContentSlotRoot>
  );
};

export default AccountingBpSlot;
